// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBar_container__3lWxu","icon":"SearchBar_icon__1LvqE","scan__icon":"SearchBar_scan__icon__3KfNp"};